import * as yup from 'yup';
import { useFormik } from 'formik';
import { useFirestore, useUser } from 'reactfire';
import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { doc, deleteDoc, collection, getDocs } from 'firebase/firestore';
import {
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';

const deleteAccountSchema = yup.object().shape({
  password: yup
    .string()
    .min(8, 'Пароль має бути не коротшим ніж 8 символів')
    .required('Обов’язкове поле'),
});

const DeleteAccountForm = () => {
  const firestore = useFirestore();
  const { data: user } = useUser();

  const formik = useFormik({
    initialValues: {
      password: '',
    },
    validationSchema: deleteAccountSchema,
    async onSubmit({ password }, { setErrors, setSubmitting }) {
      try {
        if (user && user.email) {
          const credential = EmailAuthProvider.credential(user.email, password);
          await reauthenticateWithCredential(user, credential);

          const userRef = doc(firestore, 'users', user.uid);
          await deleteDoc(userRef);

          const userConversationsRef = collection(
            firestore,
            'chats',
            user.uid,
            'conversations',
          );
          const conversationsSnapshot = await getDocs(userConversationsRef);

          const deletePromises = conversationsSnapshot.docs.map(
            (conversationDoc) => deleteDoc(conversationDoc.ref),
          );
          await Promise.all(deletePromises);

          const userChatDocRef = doc(firestore, 'chats', user.uid);
          await deleteDoc(userChatDocRef);

          await user.delete();
        }
      } catch (error) {
        setErrors({ password: 'Неправильний пароль' });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <DialogContent>
        <DialogContentText>
          Введіть пароль та натисніть "Підтведити" для видалення облікового
          запису.
        </DialogContentText>
        <TextField
          id="password"
          name="password"
          type="password"
          label="Пароль"
          margin="dense"
          variant="standard"
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          fullWidth
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button type="submit" color="error" disabled={formik.isSubmitting}>
          Підтведити
        </Button>
      </DialogActions>
    </form>
  );
};

export default DeleteAccountForm;
